export const updatePreferredWalkerResponseParser = (response: any): any => ({ ...response
});
export default updatePreferredWalkerResponseParser;